import { Collapse, Flex, Spin, Input, Typography, Table, Layout, Space, Button, Tooltip, Drawer, Radio, Empty, App } from 'antd'
import dayjs from 'dayjs'

const downloadContent = (finename, content) => {
  const textContent = content || 'No data available'
  const blob = new Blob([textContent], { type: 'text/plain' })
  const link = document.createElement('a')
  link.href = URL.createObjectURL(blob)
  link.download = finename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(link.href)
}

export const ProfileFooter = ({ prompt, input, model, datetime }) => {
  return (
    <Flex justify='flex-end' align='center'>
      <Button
        type='text'
        onClick={() => {
          downloadContent(`prompt-${Date.now()}.md`, prompt)
        }}>
        ℹ 提示词
      </Button>
      <Button
        type='text'
        onClick={() => {
          downloadContent(`input-${Date.now()}.md`, input)
        }}>
        📚 参考资料
      </Button>
      <Tooltip title={model}>
        <Button type='text'>{'🕐 ' + dayjs(datetime).format('YYYY-MM-DD hh:mm')}</Button>
      </Tooltip>
    </Flex>
  )
}
